import React, { useMemo } from 'react';
import {
  AccessibilityProps,
  ActivityIndicator,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

import { colors, fonts, scale } from '../Styles';

export type ButtonState = 'enabled' | 'disabled' | 'showingActivityIndicator';

type MNOHSButtonProps = AccessibilityProps & {
  /** The title of the button. */
  title: string;
  /** Called when the button is pressed. */
  onPress?: () => void;
  /** A style to apply to the button. By default, has `width: '75%'`. */
  style?: ViewStyle;
  /** The state to display on the button. Default is `'enabled'`. */
  state?: ButtonState;
  /** button size */
  size?: 'small' | 'default';
};

/** MNOHS-styled shared button component. */
export const MNOHSButton = (props: MNOHSButtonProps) => {
  return (
    <View style={useMemo(() => ({ width: '100%', ...props.style }), [props.style])}>
      <TouchableOpacity
        style={props.state === 'disabled' ? styles.buttonDisabled : styles.button}
        disabled={props.state === 'disabled'}
        onPress={props.onPress}
        activeOpacity={0.75}
        accessibilityLabel={props.accessibilityLabel}>
        {props.state === 'showingActivityIndicator' ? (
          <ActivityIndicator
            // this padding is very specific because we need the height of the button to stay the same when the loading indicator is shown
            style={styles.activityIndicator}
            size={24}
            color={colors.white}
          />
        ) : (
          <Text style={props.size === 'small' ? styles.smallTitle : styles.title}>{props.title}</Text>
        )}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  activityIndicator: {
    padding: scale(12.75),
  },
  button: {
    width: '100%',
    backgroundColor: colors.black,
    alignItems: 'center',
    borderRadius: scale(8),
  },
  buttonDisabled: {
    width: '100%',
    backgroundColor: colors.grayDark,
    alignItems: 'center',
    borderRadius: scale(8),
  },
  title: {
    ...fonts.header2,
    padding: scale(15),
    color: colors.white,
  },
  smallTitle: {
    ...fonts.header2,
    color: colors.white,
  },
});
